import React from "react"
import PropTypes from "prop-types"
import CollectionCard from './CollectionCard'
import LoadMoreButton from "./LoadMoreButton"
import collectionStore from "../stores/collectionStore"
import Collection from "../models/collection"

import { observer, Provider } from "mobx-react"

const stores = {
  collectionStore,
}

@observer
export default class Collections extends React.Component {
  constructor(props) {
    super(props)
    collectionStore.visibleCollections = props.collections.map(
      (collection) => new Collection(collection)
    )
  }

  renderCollectionRow(collections) {
    const collectionSlugs = collections.map( collection => collection.slug)
    return (
      <div className="row" key={collectionSlugs} >
        {collections.map((collection) => {
          return <CollectionCard collection={collection} key={collection.slug} />
        })}
      </div>
    )
  }

  render(){
    const { pagyMetadata } = this.props
    const collections = collectionStore.visibleCollections
    const collectionsCount = collections.length
    const rows = []
    let currentRow = []

    collections.map((collection, idx) => {
      currentRow.push(collection)
      if (currentRow.length === 4 || (collectionsCount - 1) === idx) {
        rows.push(currentRow)
        currentRow = []
      }
    })

    const rowsToRender = rows.map(row => {
      return this.renderCollectionRow(row)
    })
    return (
      <Provider {...stores}>
        <div className="container" id="samples" role="region" aria-label="Collections">
          {rowsToRender}
        </div>
        <LoadMoreButton pagyMetadata={pagyMetadata} />
      </Provider>
    )
  }

}
